<!--
 * @Author: xing.huang
 * @Date: 2022-06-20 10:45:51
 * @LastEditTime: 2023-03-21 14:41:38
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\order\DispatchTask\CloseDispatchOrder.vue
 * 
-->
<template>
  <div id="close-dispatch-order">
    <el-card class="table_searchbar">
      <div style="display:flex">
        <div style="margin-bottom:20px;margin-right:40px">
          <div class="" @keydown.enter="btnSearch()">
            <span class="title">工单号：</span>
            <el-select
              :loading="loading"
              style="max-width: 200px"
              clearable
              :remote-method="query => loadProductionBatchCode(query)"
              v-model="searchForm.businessOrderSplitId"
              filterable
              placeholder="工单号"
              remote
            >
              <el-option v-for="item in productionBatchCodeList" :key="item.splitId" :label="item.productionBatchCode" :value="item.splitId"></el-option>
            </el-select>
          </div>
        </div>
        <div style=" margin-right:40px">
          <div class="" @keydown.enter="btnSearch()">
            <span class="title">工序：</span>
            <el-select
              size="small"
              filterable
              :loading="loading"
              clearable
              :remote-method="query => loadProcedureList(query)"
              remote
              style="max-width:200px;"
              v-model="searchForm.procedureName"
              placeholder="工序"
            >
              <el-option style="max-width: 200px" :title="item" v-for="item in procedureList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
        </div>
        <div style=" margin-right:40px">
          <div class="">
            <span class="title">机组：</span>
            <el-select style="max-width:200px;" clearable filterable v-model="searchForm.factoryModelId" size="small" maxlength="16" placeholder="选择机组">
              <el-option v-for="item in workershopList" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </div>
        </div>
        <div style=" margin-right:40px">
          <div class="">
            <span class="title">进度：</span>
            <el-input placeholder="请输入内容" style="max-width:200px;" v-model="searchForm.progress" class="input-with-select">
              <el-select v-model="searchForm.symbol" slot="prepend" placeholder="请选择">
                <el-option label="<" value="<"></el-option>
                <el-option label=">" value=">"></el-option>
                <el-option label=">=" value=">="></el-option>
                <el-option label="＝" value="="></el-option>
              </el-select>
            </el-input>
          </div>
        </div>
        <div style="width:350px">
          <div style="text-align:right">
            <a style="margin-right: 12px;cursor: pointer;font-size: 12px;" @click="toggleShowMore">
              {{ showMore ? "收起" : "展开" }}
              <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
            </a>
            <el-button size="mini" type="primary" @click="forceFinish('all')">批量完成</el-button>
            <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
            <el-button size="mini" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
          </div>
        </div>
      </div>
      <el-collapse-transition>
        <div v-show="showMore">
          <div style="margin-bottom:20px;display:flex">
            <div style=" margin-right:40px">
              <div class="">
                <span class="title">状态：</span>
                <el-select style="max-width:200px;" clearable filterable v-model="searchForm.planState" size="small" maxlength="16" placeholder="选择状态">
                  <el-option label="待办任务" :value="0"></el-option>
                  <el-option label="执行任务" :value="4"></el-option>
                  <el-option label="办结任务" :value="1"></el-option>
                </el-select>
              </div>
            </div>
            <div class="margin-right:40px">
              <span class="title">员工：</span>
              <el-select
                size="small"
                filterable
                :loading="loading"
                clearable
                :remote-method="query => loadSelectUser(query)"
                remote
                style="max-width:200px;"
                v-model="searchForm.userId"
                placeholder="员工"
              >
                <el-option style="max-width: 200px" :title="item.name" v-for="item in selectUserList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </el-card>

    <el-card class="table-card">
      <el-table :data="tableData" style="width: 100%" class="deviceTable " ref="multipleTable" @selection-change="handleSelectionChange">
        <el-table-column width="80" type="selection" :selectable="checkboxSelect"></el-table-column>
        <el-table-column prop="productionBatchCode" label="工单号" min-width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="orderCode" label="订单号" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="materialCode" label="物料编码" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="materialName" label="物料名称" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="procedureName" label="工序名称" min-width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="dispatchGroupCode" label="派工单号" min-width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="needAmount" label="派工数量" min-width="70" show-overflow-tooltip></el-table-column>
        <el-table-column prop="finishAmount" label="报工数量" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="userName" label="人员" min-width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="deviceName" label="设备名称" min-width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="progress" label="进度" :formatter="parseProgress" min-width="60" show-overflow-tooltip></el-table-column>
        <el-table-column prop="planState" label="状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.planState == 0">待办任务</span>
            <span v-else-if="scope.row.planState == 4">执行任务</span>
            <span v-else-if="scope.row.planState == 1">办结任务</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button v-if="scope.row.planState == 4" type="text" @click="forceFinish(scope.row)" size="small">强制完成</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page" style="margin-bottom:0px" v-if="tableData.length > 0">
        <div class="total_page">
          <span> 共{{ tableTotalPage }}条 8条/页</span>
        </div>
        <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
          <el-pagination :page-size="8" background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"> </el-pagination>
        </div>
      </div>
      <div style="text-align: center;margin-bottom:20px">
        <el-button size="mini" type="primary" @click="goBack">返回</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  name: "CloseDispatchOrder",
  data() {
    let vm = this;
    return {
      showMore: false,
      dataList: [],
      form: {
        dataList: []
      },
      selectList: [],
      isShowDialog: false,
      printData: [],
      dispatchPrintList: [],
      printDialogVisible: false,
      showSave: true,
      userDialogVisible: false,
      deviceDialogVisible: false,
      userName: "",
      webSearchText: "",
      loading: false,
      productionBatchCodeList: [],
      materialList: [],
      procedureList: [],
      selectTaskId: null,
      selectUserId: null,
      selectDeviceId: null,
      fristLoad: false,
      addForm: {
        planDetailTableList: []
      },
      showAdd: true,
      userList: [],
      deviceList: [],
      dispatchList: [],
      tableData: [],
      statusOption: [
        //0-未派工|1-部分派工|2-已派工|3-已完成
        { label: "未派工", value: 0 },
        { label: "部分派工", value: 1 },
        { label: "已派工", value: 2 },
        { label: "已完成", value: 3 }
      ],
      selectRowList: [],
      selectId: null,
      isDisabled: false,
      W: false,
      btnPressType: 0, //按钮类型： 0-默认 1-查询 2-重置 3-分页
      searchFormTemp: "", //临时搜索数据
      searchForm: {
        procedureName: "",
        businessOrderSplitId: null,
        progress: null,
        factoryModelId: null,
        symbol: ">",
        userId: null,
        planState: ""
      },
      tableTotalPage: 1,
      tableCurrentPage: 1,
      selecTaskRow: {},
      viewDialogVisible: false,
      addForm: {
        detailList: []
      },
      selectUserList: [],
      rules: {
        reworkType: [{ required: true, message: "请选择返工路径", trigger: "blur" }],
        technologyId: [{ required: true, message: "请选择返工类型", trigger: "blur" }],
        actualAmount: [
          { required: true, message: "请输入完成数量", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (Number(value) > 0) {
                callback();
              } else {
                callback(new Error("数量必须大于零"));
              }
            },
            trigger: "blur"
          }
        ]
      },
      workershopList: [],
      factoryModelId: [],
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },
  mounted: function() {
    this.initTable();
    this.loadProductionBatchCode();
    this.loadProcedureList();
    this.loadWorkShopList();
    this.loadSelectUser();
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
  },
  computed: {
    span() {
      return this.W ? 8 : 8;
    }
  },

  filters: {
    showSubmitTime(ev, show) {
      return commonUtils.timestampToDate(ev, show);
    },
    paseRate(ev) {
      ev = Number(ev);
      if (ev || ev == 0) {
        ev.toFixed();
        return ev + "%";
      }
    }
  },
  deactivated: function() {
    console.log("deactivated");
  },
  methods: {
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
    goBack() {
      this.$parent.showPage = 0;
    },
    async loadSelectUser(workerName) {
      let { code, data } = await this.$RequestUtil.getAsync({ url: "/api/select/listWorker", params: { workerName } });
      if (code == 0) {
        this.selectUserList = data;
      }
    },
    checkboxSelect(row) {
      if (row.planState == 4) {
        return true;
      } else {
        return false;
      }
    },
    getRemainingAmount(row) {
      let remainingAmount = row.needAmount - row.finishAmount;
      if (isNaN(remainingAmount) || remainingAmount < 0) {
        remainingAmount = 0;
      }
      return remainingAmount;
    },
    loadWorkShopList() {
      this.$RequestUtil.get({
        url: "/api/factoryModel/getWorkShopList",
        // type:'sync',
        params: {},
        success: res => {
          if (res.code == 0) {
            this.workershopList = res.data;
          } else {
            this.$message.error(res.msg || res.message);
          }
        }
      });
    },
    async loadProductionBatchCode(productionBatchCode) {
      this.loading = true;
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({
        url: "/api/select/listProductionBatchCode",
        type: "async",
        params: { productionBatchCode }
      });
      this.productionBatchCodeList = data;
      this.loading = false;
    },
    async loadProcedureList(procedureName) {
      this.loading = true;
      let { data } = await this.$RequestUtil.getAsync({
        url: "/api/select/listProcedure",
        type: "sync",
        params: { procedureName }
      });
      this.procedureList = data;
      this.loading = false;
    },
    handleCheckedChange() {},
    selectedHighlight({ row, rowIndex }) {
      if (this.selectId == row.businessOrderDispatchGroupId) {
        return {
          "background-color": "#409EFF",
          color: "#fff",
          cursor: "pointer"
        };
      }
      return { cursor: "pointer" };
    },

    async rowClick(row, column, event) {},

    parseProgress(rowData) {
      if (rowData.progress) {
        return rowData.progress + "%";
      }
    },

    async printOrder(rowData) {
      rowData.productionBatchCode = this.selectRowList[0].productionBatchCode;
      localStorage.setItem("printDispatchTask", JSON.stringify([rowData]));
      let routeUrl = this.$router.resolve({ path: "/Print/printDispatchTask" });
      window.open(routeUrl.href, "_blank");
    },

    btnSearch: function() {
      this.tableCurrentPage = 1;
      this.btnPressType = 1;
      this.search();
    },

    clearSearch() {
      let form = this.searchForm;
      this.btnPressType = 2;
      form.businessOrderSplitId = null;
      form.procedureName = "";
      form.progress = null;
      form.symbol = ">";
      form.factoryModelId = null;
      form.userId = null;
      form.planState = "";
    },

    search: function(fn, id) {
      let temp;
      switch (this.btnPressType) {
        case 1:
          temp = commonUtils.cloneObj(this.searchForm);
          this.searchFormTemp = commonUtils.cloneObj(temp);
          break;
        case 0:
          temp = {
            procedureName: "",
            businessOrderSplitId: null,
            materialId: null,
            progress: null,
            factoryModelId: null,
            symbol: ">",
            userId: null,
            planState: ""
          };
          break;
        case 2:
          temp = this.searchFormTemp;
          break;
        case 3:
          temp = this.searchFormTemp;
          break;
      }
      this.$RequestUtil.get({
        url: "/api/businessOrderDispatch/listBatchComplete",
        type: "sync",
        params: {
          pageNum: this.tableCurrentPage,
          pageSize: 8,
          businessOrderSplitId: temp.businessOrderSplitId,
          procedureName: temp.procedureName,
          materialId: temp.materialId,
          progress: temp.progress,
          factoryModelId: temp.factoryModelId,
          symbol: temp.symbol,
          userId: temp.userId,
          planState: temp.planState
        },
        success: async res => {
          if (res.msg == this.$Global.RESPONSE.SUCCESS) {
            this.tableData = res.data;
            this.tableTotalPage = res.totalPages;
            if (res.totalPages == 0 && this.fristLoad) {
              this.$message.warning("查询不到符合条件的数据");
            }
          } else {
            this.$message.error(res.message || res.msg);
          }
        }
      });
    },

    pageChange: function(targetPage) {
      this.tableCurrentPage = targetPage;
      this.btnPressType = 3;
      this.search();
    },

    initTable: function() {
      this.search();
    },

    parseDate: function(rowData) {
      if (rowData.gmtCreate != null) {
        let dateString = commonUtils.timestampToDate(rowData.gmtCreate, true);
        return dateString;
      }
    },
    handleSelectionChange(ev) {
      this.selectList = ev.map(item => item.id);
    },
    forceFinish: function(rowData) {
      this.$confirm(`该任务强制完成后不可撤销，是否确认强制完成?`, "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let idList = [];
        if (rowData != "all") {
          idList = [rowData.id];
        } else {
          if (this.selectList.length == 0) {
            this.$message.warning("请先勾选需要强制完成工单");
            return;
          }
          idList = this.selectList;
        }
        this.$RequestUtil.post({
          url: "/api/productionPlan/forceFinish",
          type: "sync",
          params: { idList },
          success: res => {
            if (res.code == 0) {
              this.search();
              this.$message.success("强制完成任务");
              this.$parent.search();
            } else {
              this.$message.error(res.msg || res.message);
            }
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.item-warp {
  /* display: flex; */
  width: 100%;
  margin-top: -16px;
  display: grid;
  grid-column-gap: 20px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.table-item {
  flex: 1;
  /* margin-right: 20px; */
}

.dialog-footer {
  margin-top: -20px;
}

.delete {
  width: 18px;
  height: 19px;
  background-image: url("/static/img/del.png");
  cursor: pointer;
  background-repeat: no-repeat;
}

.delete:hover {
  background-image: url("/static/img/del-hover.png");
  background-repeat: no-repeat;
}

.table_searchbar .title11 {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
  width: 60px;
  text-align: right;
  display: inline-block;
}

.add_form .title {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
  display: inline-block;
  text-align: right;
  width: 70px;
}
.view_form .title {
  text-align: left;
  width: auto;
}
.add_form .value {
  display: inline-block;
}

.el-row {
  margin-bottom: 20px;

  & :last-child {
    margin-bottom: 0;
  }
}

.page {
  display: flex;
  justify-content: flex-end;
}

@media screen and (max-width: 1380px) {
  .page {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}

.total_page {
  margin-top: 20px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}
</style>
<style>
.table_searchbar .el-button--mini,
.el-button--mini.is-round {
  padding: 7px 10px;
}

.el-textarea .el-input__count {
  line-height: 12px;
}

#dispatch-task .task-list .el-table__body tr:hover > td,
#dispatch-task .task-list .el-table__body tr:hover > td .el-button--text {
  color: #fff;
  background-color: #409eff;
}

#dispatch-task .task-list .select-row .el-button--text {
  color: #fff;
}
#close-dispatch-order .el-input-group__prepend {
  padding: 0 10px;
}
#close-dispatch-order .el-input-group__prepend .el-input {
  width: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/DispatchTask/CloseDispatchOrder.vue